/** Chave em `user.experimental_features` (API user) para listagem/edição Produtos V2. */
export const PRODUCTS_V2_EXPERIMENTAL_FLAG = 'products_v2';

/**
 * Chave em `user.experimental_features` que decide se o produtor entra no Dashboard V2.
 * Separada de `product_multicurrency` porque as duas capacidades são independentes: dá para
 * querer o dashboard novo sem vender em dólar. Enquanto era uma flag só, liberar o Dashboard V2
 * ligava o USD junto (seletor de moeda, OXXO/SPEI) sem ninguém decidir por isso.
 */
export const DASHBOARD_V2_EXPERIMENTAL_FLAG = 'dashboard_v2';

/** Chave em `user.experimental_features` para habilitar o fluxo multiconta. */
export const MULTI_ACCOUNT_EXPERIMENTAL_FLAG = 'multi_account';

/**
 * Chave em `user.experimental_features` que libera multimoeda. O front não lê direto: passa por
 * `hasMultiCurrency` (`@/utils/multicurrency`), que prefere `user.multicurrencyEnabled` e só cai
 * nesta lista quando o backend não manda o campo.
 */
export const PRODUCT_MULTICURRENCY_EXPERIMENTAL_FLAG = 'product_multicurrency';

/** Chave em `user.experimental_features` para habilitar a Área de Membros Cakto V2. */
export const CAKTO_MEMBERS_V2_EXPERIMENTAL_FLAG = 'cakto_members_v2';

/**
 * Chave em `user.experimental_features` para a exigência de nota fiscal dos coprodutores.
 *
 * Recorta quem pode **ligar** a exigência — ligar retém o repasse de terceiro
 * até ele emitir a nota. Não recorta quem **deve** a nota: um produtor do piloto
 * pode ter coprodutor fora dele, e esconder a lista de pendências prenderia o
 * repasse de quem não teria como destravá-lo.
 */
export const COPRODUCER_INVOICE_EXPERIMENTAL_FLAG = 'coproducer_invoice';

/**
 * Chave em `user.experimental_features` para o redirect pós-pagamento por produto.
 *
 * Gateia só a **exibição** do campo na edição do produto. Quem barra a gravação é o
 * `validate_postPaymentRedirectUrl` do backend: esconder aqui não impede um PATCH direto.
 */
export const POST_PAYMENT_REDIRECT_EXPERIMENTAL_FLAG = 'post_payment_redirect';

/**
 * Chave em `user.experimental_features` para Minhas Vendas com os order bumps dentro da venda
 * principal (CKTPL-1363). É piloto por conta porque agrupar deixa à vista que a taxa fixa sai por
 * pedido, e cada bump é um pedido. Sem ela o backend recusa a rota agrupada (403).
 */
export const ORDERBUMP_GROUPING_EXPERIMENTAL_FLAG = 'orderbump_grouping';

/**
 * Chave em `user.experimental_features` para o extrato do saldo Cakto Checkout (entrou, saiu e o
 * saldo depois de cada lançamento). Piloto nas contas @cakto; sem ela o backend recusa a rota (403)
 * e a tela "Extrato do checkout" segue só com os saques.
 */
export const FINANCIAL_STATEMENT_EXPERIMENTAL_FLAG = 'financial_statement';
